export class ClinicMedicationRequest {
  private Action = 'clinicmedication';
  public PublicToken: string;

  constructor({ PublicToken }) {
    this.PublicToken = PublicToken;
  }
}
